import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface ImageLightboxProps {
  src: string;
  alt?: string;
  onClose: () => void;
}

export const ImageLightbox: React.FC<ImageLightboxProps> = ({ src, alt = '', onClose }) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        onClose();
      }
    };

    // Listen in capture phase to intercept Escape before parent handlers
    window.addEventListener('keydown', handleEscape, true);
    return () => window.removeEventListener('keydown', handleEscape, true);
  }, [onClose]);

  if (!src) return null;

  return createPortal(
    <div className="image-lightbox-overlay" data-modal-root="true" onClick={onClose}>
      <div className="image-lightbox-content" onClick={e => e.stopPropagation()}>
        <button className="image-lightbox-close" onClick={onClose}>×</button>
        <img 
          src={src} 
          alt={alt} 
          className="image-lightbox-img" 
        />
      </div>
    </div>,
    document.body
  );
};
